import React from "react";
import styles from "./ImageGrid.module.scss";
import { Icon } from "../../atoms/Icon";
import { ImageInput } from "../../atoms/ImageInput";
import { Spinner } from "@blueprintjs/core";

function ImageGrid({ loading, setLoading, children, onAddItem }) {
  if (loading) {
    return (
      <div className={styles.imagesLoading}>
        <Spinner />
      </div>
    );
  }

  return (
    <div>
      <div className={styles.imageList}>
        {children}

        <ImageInput
          onImageSelect={onAddItem}
          setLoading={setLoading}
          allowMultiSelect
        >
          <div className={styles.imageListItem}>
            <div className={styles.fakeImg} />
            <div className={styles.iconPositionWrapper}>
              <Icon
                size={21}
                color="#9fa9ba"
                className={styles.icon}
                name="Add-Circle"
              />
            </div>
          </div>
        </ImageInput>
      </div>
    </div>
  );
}

export default ImageGrid;
